import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditStrategicAxisRequestFailure({ uuid }) {
      const state = getState().find(
        ({ strategicAxis }) => strategicAxis.uuid === uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isEditStrategicAxisRequestPending({ uuid }) {
      const state = getState().find(
        ({ strategicAxis }) => strategicAxis.uuid === uuid,
      );

      return state ? state.request.isPending : false;
    },
    isEditStrategicAxisRequestSuccess({ uuid }) {
      const state = getState().find(
        ({ strategicAxis }) => strategicAxis.uuid === uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
